// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"39e2cc3c","239":"dfdb0d71","451":"69f85615","455":"f5e9eb1b","977":"3fd645a6"}[chunkId] + ".chunk.js";
};